import { useParams, Link } from "react-router-dom";
import useIsMobile from "../hooks/useIsMobile";
import useSheetData from "../hooks/useSheetData";
import Reveal from "../components/common/Reveal";
import Icon from "../components/common/Icon";
import Seo from "../components/common/Seo";
import { SheetLoading } from "../components/common/SheetState";
import { colors, fonts, btnOutline, btnPrimary, maxW } from "../styles/theme";
import slugify from "../utils/slugify";
import { getLinkMeta } from "../utils/portfolioLink";

export default function ProjectDetailPage() {
  const mob = useIsMobile();
  const { slug } = useParams();
  const { data: rows, status } = useSheetData("Portfolio");
  const project = rows.find((p) => (p.slug || slugify(p.title)) === slug);

  if (status === "loading") {
    return (
      <div style={{ background: colors.paper, minHeight: "100vh", paddingTop: 74, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <SheetLoading label="Loading project…" />
      </div>
    );
  }

  return (
    <div style={{ background: colors.paper, minHeight: "100vh", paddingTop: 74, display: "flex", alignItems: "center" }}>
      <Seo
        title={project ? `${project.title} | Charith Portfolio` : "Project | Charith"}
        description={project ? project.desc : "Case study coming soon from Charith."}
        path={`/portfolio/${slug}`}
      />
      <Reveal style={{ ...maxW, textAlign: "center", padding: mob ? "60px 6%" : "80px 6%" }}>
        <Icon name="Briefcase" size={30} style={{ color: colors.rust, marginBottom: 20 }} />
        <h1 style={{ fontFamily: fonts.display, fontWeight: 600, fontSize: mob ? 26 : 32, color: colors.ink, marginBottom: 14 }}>
          {project ? project.title : "Case study coming soon"}
        </h1>
        <p style={{ color: colors.inkFaint, fontFamily: fonts.body, fontSize: mob ? 14.5 : 15.5, lineHeight: 1.75, maxWidth: 460, margin: "0 auto 28px" }}>
          {project
            ? "We're still writing up the full case study for this project — check back shortly."
            : "This project either hasn't been published yet or the link has moved."}
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          {project?.playstoreurl && (() => {
            const link = getLinkMeta(project.type);
            return (
              <a href={project.playstoreurl} target="_blank" rel="noreferrer" style={{ ...btnPrimary, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>
                {link.label} <Icon name={link.icon} size={15} />
              </a>
            );
          })()}
          <Link to="/portfolio" style={{ ...btnOutline, textDecoration: "none", display: "inline-block" }}>Back to Portfolio</Link>
        </div>
      </Reveal>
    </div>
  );
}
